/*
  ENRICHD – show Outsell upsell discounts in the cart drawer (Oct 2026)

  Outsell ("You may also like" popup) adds offer items to the cart at FULL price and only
  applies its discount at checkout (it builds a draft order from the cart + the offers the
  customer accepted, which it keeps in localStorage "os_offers"). So the Shopify cart never
  contains the discount and the drawer showed full price.

  This script is DISPLAY ONLY. It reads the same "os_offers" record Outsell uses, looks up
  each accepted offer's discount from Outsell, and shows the offer price in the cart drawer:
  struck-through full price + offer price on the line, and an estimated total under the
  subtotal. Outsell still applies the actual discount at checkout. If nothing matches, the
  drawer is left exactly as the theme renders it.
*/
(function () {
  'use strict';

  var OFFERS_KEY = 'os_offers';
  var CACHE_KEY = 'enr_outsell_offer_cache_v1';
  var SHOP = 'enrichd-superfoods.myshopify.com';
  var API = 'https://outsellapp.com/api/v1/script/getOffersByTrigger';
  var NOTE = 'Offer price – applied at checkout';

  function readJSON(store, key) {
    try { return JSON.parse(store.getItem(key)) || null; } catch (e) { return null; }
  }
  function writeJSON(store, key, value) {
    try { store.setItem(key, JSON.stringify(value)); } catch (e) {}
  }

  function acceptedOffers() {
    var data = readJSON(window.localStorage, OFFERS_KEY);
    return (data && Array.isArray(data.acceptedOffers)) ? data.acceptedOffers : [];
  }

  function currencyCode() {
    return (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP';
  }
  function money(pence) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
        style: 'currency', currency: currencyCode()
      }).format(pence / 100);
    } catch (e) { return '£' + (pence / 100).toFixed(2); }
  }

  // offerId -> { type, value }. Looked up from Outsell using the cart's own variants as triggers.
  async function offerDiscounts(cart, accepted) {
    var cache = readJSON(window.sessionStorage, CACHE_KEY) || { offers: {}, tried: {} };
    var missing = function () {
      return accepted.some(function (a) { return !cache.offers[a.offerId]; });
    };
    if (missing()) {
      for (var i = 0; i < cart.items.length && missing(); i++) {
        var vid = cart.items[i].variant_id;
        if (cache.tried[vid]) continue;
        cache.tried[vid] = 1;
        try {
          var res = await fetch(API + '?shop=' + encodeURIComponent(SHOP) + '&variantId=' + vid);
          var json = await res.json();
          var offers = (json && json.data && json.data.offers) || [];
          offers.forEach(function (o) {
            cache.offers[o._id] = { type: o.discountType, value: Number(o.discountValue) || 0 };
          });
        } catch (e) {}
      }
      writeJSON(window.sessionStorage, CACHE_KEY, cache);
    }
    return cache.offers;
  }

  // Same rule Outsell uses when it builds the draft order: units up to quantityAdded get the offer.
  function lineSaving(item, offer, acc) {
    if (!offer || !offer.value) return 0;
    var units = Math.min(item.quantity, (acc.itemAdded && acc.itemAdded.quantityAdded) || item.quantity);
    var perUnit = 0;
    if (offer.type === 'percentage') perUnit = Math.round(item.price * offer.value);
    else if (offer.type === 'fixedAmount') perUnit = Math.min(item.price, Math.round(offer.value * 100));
    return Math.max(0, perUnit * units);
  }

  var running = false, pending = false;

  async function apply() {
    if (running) { pending = true; return; }
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    var accepted = acceptedOffers();
    if (!accepted.length) return;

    running = true;
    try {
      var cart = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json();
      if (!cart || !cart.items || !cart.items.length) return;
      var offers = await offerDiscounts(cart, accepted);

      var totalSaving = 0;
      drawer.querySelectorAll('.cart-drawer__product_card').forEach(function (card) {
        var qtyEl = card.querySelector('cart-quantity[data-item-index]');
        var priceWrap = card.querySelector('.cart-drawer__product-card--price');
        if (!qtyEl || !priceWrap) return;
        var item = cart.items[Number(qtyEl.getAttribute('data-item-index')) - 1];
        if (!item) return;

        var acc = accepted.find(function (a) {
          return a.itemAdded && String(a.itemAdded.variantId) === String(item.variant_id);
        });
        var saving = acc ? lineSaving(item, offers[acc.offerId], acc) : 0;
        var sig = item.key + ':' + item.quantity + ':' + saving;
        if (priceWrap.getAttribute('data-enr-offer') === sig) { totalSaving += saving; return; }

        if (!priceWrap.hasAttribute('data-enr-original')) {
          priceWrap.setAttribute('data-enr-original', priceWrap.innerHTML);
        }
        if (saving > 0) {
          priceWrap.innerHTML =
            '<s class="enr-offer-was" style="opacity:.6;font-weight:normal">' + money(item.final_line_price) + '</s> ' +
            '<span class="enr-offer-now">' + money(item.final_line_price - saving) + '</span>' +
            '<small class="enr-offer-note" style="display:block;font-size:12px;opacity:.75;font-weight:normal">' + NOTE + '</small>';
        } else {
          priceWrap.innerHTML = priceWrap.getAttribute('data-enr-original');
        }
        priceWrap.setAttribute('data-enr-offer', sig);
        totalSaving += saving;
      });

      var sub = drawer.querySelector('.cart-drawer__subtotal--price');
      var btnPrice = drawer.querySelector('.cart-drawer__footer--button-price');
      [sub, btnPrice].forEach(function (el) {
        if (el && !el.hasAttribute('data-enr-original')) el.setAttribute('data-enr-original', el.innerHTML);
      });
      if (totalSaving > 0) {
        var est = cart.total_price - totalSaving;
        if (sub) {
          sub.innerHTML =
            '<s style="opacity:.6;font-size:.7em;font-weight:normal">' + money(cart.total_price) + '</s> ' +
            '<span>' + money(est) + '</span>' +
            '<small style="display:block;font-size:12px;opacity:.75;font-weight:normal">Includes ' +
            money(totalSaving) + ' offer savings, applied at checkout</small>';
        }
        if (btnPrice) btnPrice.textContent = ' · ' + money(est);
      } else {
        [sub, btnPrice].forEach(function (el) {
          if (el && el.hasAttribute('data-enr-original')) el.innerHTML = el.getAttribute('data-enr-original');
        });
      }
    } catch (e) {
      // Never break the cart: on any error leave the theme's own prices in place.
    } finally {
      running = false;
      if (pending) { pending = false; schedule(); }
    }
  }

  var timer = null;
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(apply, 150);
  }

  function watch() {
    var target = document.getElementById('shopify-section-cart-drawer') || document.body;
    new MutationObserver(function (mutations) {
      // Ignore the changes this script makes itself.
      var external = mutations.some(function (m) {
        var t = m.target;
        return !(t.closest && t.closest('[data-enr-original]'));
      });
      if (external) schedule();
    }).observe(target, { childList: true, subtree: true });
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.site-header__cart-toggle, [data-cart-toggle], .js-drawer-open-right-link')) schedule();
    }, true);
    schedule();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
  else watch();
})();
